<template>
  <div>
    <table class="table_file">
      <tbody>
        <tr v-for="(file,index) in fileData" :key="index">
          <td>
            <i class="fonticon source"></i>
            <span class="nameover_file" :title="file.name">{{file.name}}</span>
            <span v-if="file.size">{{(file.size/1024).toFixed(2)}}K</span>
            <span>
              <el-button type="text" @click="viewFile(file)">预览</el-button>
              <el-button type="text" @click="handleFileDown(1,file)">下载</el-button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <show-file @close="close" :file="file" :showFile="showFile"></show-file>
  </div>
</template>
<script>
import showFile from "@/components/showFile/index.vue";
import { deleteFile, rename, downFile } from "@/api/file";
import { getHzm, toLower } from "@/utils/util";
export default {
  name: "fileEdit",
  props: [
    "fileData",
    "type",
    "sorceShow",
    "read",
    "isDownload",
    "isBack",
    "fileHeight"
  ],
  data() {
    return {
      checkAll: false,
      checkedAll: [],
      showFile: false,
      file: null
    };
  },
  components: { showFile },
  methods: {
    downFile(file) {
      downFile({
        fileid: file.id
      }).then(res => {
        window.open(res.data, "_blank");
      });
    },
    handleCheckAllChange(val) {
      if (val) {
        this.fileData.forEach(item => {
          this.checkedAll.push(item.id);
          item.checked = true;
        });
      } else {
        this.checkedAll = [];
        this.fileData.forEach(item => {
          item.checked = false;
        });
      }
      this.$emit("getNewFile", this.fileData);
    },
    handleCheckedChange(e) {
      this.checkedAll = e;
      this.checkAll = this.checkedAll.length == this.fileData.length;
      this.fileData.forEach(item => {
        item.checked = false;
        this.checkedAll.forEach(chk => {
          if (chk == item.id) {
            item.checked = true;
          }
        });
      });
      this.$emit("getNewFile", this.fileData);
    },
    viewFile(file) {
      var hzm = getHzm(file);
      if (hzm == "rar" || hzm == "zip" || hzm == "RAR" || hzm == "ZIP") {
        this.$message({
          type: "warning",
          message: "压缩包不支持预览",
          duration: 1500
        });
        return false;
      } else {
        this.file = file;
        this.showFile = true;
      }
    },
    moveTag(file) {
      this.$emit("getMoveFile", file);
    },
    renameTag(file) {
      var hzm = getHzm(file);
      this.$prompt("请输入资料名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputValue: file.name.substring(0, file.name.lastIndexOf(".")),
        inputPattern: /^[。，；？：‘’“”！、《》【】〔〕（）\[\](){}~·`!@#$%^& ,.';+_=A-Za-z0-9\u4e00-\u9fa5(—{2})-]{1,40}$/,
        inputErrorMessage: "资料名格式不正确",
        inputValidator: value => {
          var validator = true;
          var vname = value + "." + hzm;
          this.fileData.forEach(item => {
            if (toLower(item.name) == toLower(vname) && item.id != file.id) {
              validator = false;
            }
          });
          return validator;
        },
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 300);
          } else {
            done();
          }
        }
      })
        .then(({ value }) => {
          var nname = value + "." + hzm;
          rename({
            id: file.id,
            name: nname
          }).then(res => {
            file.name = res.data;
            this.$emit("getNewFile", this.fileData);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    deleteTag(file) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteFile({
            fileid: file.id
          }).then(() => {
            this.$emit("getDelFile", file.id);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteBackFile(file) {
      //反馈进展 和发布任务时选择删除附件是删除任务模块的附件  不允许调用附件模块
      this.$emit("deleteFile", file);
    },
    close() {
      this.showFile = false;
    }
  }
};
</script>
<style scoped>
.source::before {
  content: "\E61C";
  color: #c0c4cc;
  font-weight: 700;
  font-size: 18px;
}
.table_file span {
  margin: 0 5px;
}
.fdList {
  height: 205px;
  overflow: auto;
  margin-top: 8px;
}
.mt16 {
  margin-top: 16px;
}
.nameover_file {
  /* width: 100%; */
  /* width: 150px; */
  max-width: 750px;
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table_file .el-button--text {
  color:#CA2328 !important;
}
</style>
<style scoped>
/* 表格样式 */

.table_file {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  box-sizing: border-box;
}

.table_file thead {
  background-color: #f9fafb;
  border-bottom: 1px solid #e8e8e8;
}

.table_file th {
  padding-left: 8px;
  font-size: 14px;
}

.table_file tr {
  line-height: 40px;
  color: #4a4a4a;
}

.table_file tbody tr {
  /* border-bottom: 1px solid #e8e8e8; */
}

.table_file tbody tr:hover {
  background-color: #f9fafb;
}

.table_file tbody td {
  max-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/fileEdit/index.vue